import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import ErrorBoundary from './components/ErrorBoundary'
import React from 'react'

// Create a client
const queryClient = new QueryClient()

// Dynamically import Analytics only in production
const AnalyticsComponent = process.env.NODE_ENV === 'production' 
  ? React.lazy(() => import('@vercel/analytics/react').then(mod => ({ 
      default: () => <mod.Analytics 
        beforeSend={(event) => process.env.NODE_ENV === 'production' ? event : null} 
      /> 
    })))
  : () => null;

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <App />
          <React.Suspense fallback={null}>
            <AnalyticsComponent />
          </React.Suspense>
        </HelmetProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
